import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: 'app/login',
    },
    {
      path: '/app',
      redirect: 'login',
      component: () => import('@/pages/Subscriber/Subscriber.vue'),
      children: [
        {
          path: 'login',
          name: 'Login',
          component: () => import('@/pages/Subscriber/Login.vue'),
          meta: {
            title: 'Authentification',
            beforeResolve(routeTo, routeFrom, next) {
              if (localStorage.getItem('access_token')) {
                next({ name: 'Profile', })
              } else {
                next()
              }
            },
          },
        },
        {
          path: 'welcome',
          name: 'Welcome',
          component: () => import('@/pages/Subscriber/Welcome.vue'),
          meta: {
            title: 'Bienvenue',
            authRequired: true,
            roleGuard: 'SUBSCRIBER',
          },
        },
        {
          path: 'profile',
          name: 'Profile',
          component: () => import('@/pages/Subscriber/Profile.vue'),
          meta: {
            title: 'Votre Dossier',
            authRequired: true,
            roleGuard: 'SUBSCRIBER',
            showHeader: true,
          },
        },
        {
          path: 'subscription/:page?',
          name: 'Subscription',
          component: () => import('@/pages/Subscriber/Subscription.vue'),
          meta: {
            title: 'Votre Dossier',
            authRequired: true,
            roleGuard: 'SUBSCRIBER',
            showHeader: true,
          },
        },
        {
          path: 'validation',
          name: 'Validation',
          component: () => import('@/pages/Subscriber/Validation.vue'),
          meta: {
            title: 'Validation',
            authRequired: true,
            roleGuard: 'SUBSCRIBER',
            showHeader: true,
          },
        },
      ],
    },
    {
      path: '/crm',
      name: 'Admin',
      component: () => import('@/pages/CRM/Admin.vue'),
      redirect: 'crm/login-crm',
      meta: {
        title: 'Admin CRM',
      },
      children: [
        {
          path: 'login-crm',
          name: 'LoginCRM',
          component: () => import('@/pages/CRM/Login.vue'),
          meta: {
            title: 'Authentification',
            beforeResolve(routeTo, routeFrom, next) {
              if (localStorage.getItem('access_token')) {
                next({ name: 'UsersList', })
              } else {
                next()
              }
            },
          },
        },
        {
          path: 'users/list',
          name: 'UsersList',
          component: () => import('@/pages/CRM/UsersList.vue'),
          meta: {
            title: 'CRM Users List',
            authRequired: true,
            roleGuard: 'ADMIN',
            showHeader: true,
            adminHeader: true,
          },
        },
        {
          path: 'users/:id',
          name: 'CustomerDetails',
          component: () => import('@/pages/CRM/CustomerDetails/CustomerDetails.vue'),
          meta: {
            title: 'CRM User Details',
            authRequired: true,
            roleGuard: 'ADMIN',
            showHeader: true,
            adminHeader: true,
          },
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // Check if auth is required on this route
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
  const roleAuthorization = routeTo.matched.some(
    (route) =>
      (route.meta.roleGuard && route.meta.roleGuard === 'ALL') ||
      route.meta.roleGuard === store.getters['profile/currentUserRole']
  )

  // If auth isn't required for the route, just continue.
  if (!authRequired) return next()
  // @todo: enhance the auth guard
  if (localStorage.getItem('access_token') && roleAuthorization) {
    next()
  } else {
    redirectToLogin(routeTo.path)
  }

  // If auth is required and the user is NOT currently logged in,
  // redirect to login.
  // redirectToLogin()

  function redirectToLogin(routeToPath, redirectFrom = '') {
    const name = routeToPath.match(/crm/) ? 'LoginCRM' : 'Login'
    const loginRoute = { name, }
    if (redirectFrom) {
      loginRoute.query = { redirectFrom, }
    }
    next(loginRoute)
  }
})

export default router
